<template>
	<div class="feedback">
		<nav-bar navBarTitle="意见反馈"></nav-bar>
		<div class="feedback-content">
			<div class="feedback-form">
				<h1>问题/意见描述</h1>
				<div class="base-cell" @click="show=true">
					<div class="base-cell-value">
						<div class="base-cell-body">
							<van-field
								v-model="content"
								rows="5"
								type="textarea"
								placeholder="请输入"
								@input="changeInfo"
								:maxlength="200"
							/>
							<div class="base-cell-word-limit"><span :class="[wordColor]">{{ inputNum }}</span>/200</div>
						</div>
					</div>
				</div>
				<van-uploader v-model="fileList" :accept="'image/*'"  upload-icon='icon iconfont iconCombinedShape' :max-count="3" :after-read="afterRead" />
			</div>
			<div class="place-div"></div>
			<div class="feedback-form">
				<h1>联系方式(选填)</h1>
				<van-field
					v-model="contactRelease"
					placeholder="请输入联系方式"
					type="input"
					:maxlength="50"
				/>
			</div>
		</div>

		<div class="sticky-block">
			<button class="button sticky-bottom btn-blue-no-shadow" @click="submit">保存</button>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'
	import { reqSubmitFeedback } from '../../api';
	import Toast from 'vant/es/toast';
	import { reqFileUpload } from '../../api/api_base';
	export default {
		name: 'feedback',
		components: {
		},
		created(){
			this.telPhone = this.formattedMobile
			this.contactRelease =  this.formattedMobile
		},
		computed: {
			wordColor: {
				get() {
					return this.content.length > 200 ? 'red': 'blue'
				},
				set (v) {
					console.log(v)
				}
			},
			...mapGetters(['formattedMobile'])
		},
		data() {
			return {
				inputNum: 0, // 已经输入字数
				telPhone: '', // 手机号
				fileList: [], // 图片内容
				content:'', // 反馈内容
				contactRelease: '', // 联系方式
				disabled: false
			}
		},
		methods: {
			changeInfo() {
				this.inputNum = this.content.length;
			},
			//  图片上传回调
			afterRead(file, name) {
				let index = name.index
				const formdata = new FormData();
				formdata.append('files', file.file);
				formdata.append('business', 'feedback')
				reqFileUpload(formdata).then( (res)=> {
					if(res.data.length){
						this.$set(this.fileList, index, {url: res.data[0]})
					}
				})
			},
			// 保存
			submit() {
				if(!this.content.trim()){
					Toast('问题/意见描述不能为空')
					return
				}
				if(this.disabled) return
				this.disabled = true
				let params = {
					accessory: this.fileList.map((item)=>item.url),
					content: this.content ||  null,
					contactRelease: this.telPhone&&this.contactRelease===this.telPhone ? null : this.contactRelease || null,
					userId : localStorage.getItem('uerId')
				}
				reqSubmitFeedback(params).then(()=>{
					Toast('提交成功')
					setTimeout((()=>{
						this.disabled = false
						this.$router.push({path: '/member'})
					}),2000)
				})
			}
		},
	};
</script>

<style lang="less" scoped>
	.feedback {
		padding-bottom: 90px;
		.place-div{
			background: #F5F5F5;
			height: 10px;
			width: 100%;
		}
		.feedback-form{
			padding: 0 16px;
			background: #ffffff;
			>h1 {
				padding: 20px 0;
				font-weight: bold;
			}
			/dee/ .van-uploader {
				/*width: 100%;*/
			}
			/deep/ .van-uploader__wrapper{
				justify-content: space-between;
				flex-wrap: nowrap;
			}
			/deep/ .van-uploader__upload {
				width: 109px;
				height: 109px;
				margin: 0 6px 16px 0;
			}
			/deep/ .van-uploader__preview-image {
				width: 109px;
				height: 109px;
			}
			/deep/ .van-uploader__preview {
				margin: 0 6px 6px 0;
			}
			/deep/  .van-cell::after {
				border-bottom: 0;
			}
			/deep/ .van-cell{
				padding: 0;
				font-size:16px;
			}
			/deep/ .van-field__control{
				padding-bottom: 16px;
				color:#888888;
			}
			/deep/ .van-uploader__preview-delete{
				position: absolute;
				top: 0;
				right: 0;
				width: 18px;
				height: 18px;
				background: url('../../assets/img/member/feedback_close.png') center;
				background-size: cover;
				border-radius: 0 0 0 0px;
			}
			/deep/ .van-icon-cross::before{
				content: '';
			}
			/deep/ .van-uploader__preview-delete-icon{
				font-size: 24px;
				height: 18px;
				line-height: 18px;
			}
			/deep/ .iconCombinedShape{
				font-size: 32px;
			}
		}
		.base-cell {
			position: relative;
			display: flex;
			align-items: center;
			box-sizing: border-box;
			width: 100%;
			background: #ffffff;
			padding: 0 ;
			.base-cell-title {
				flex: none;
				box-sizing: border-box;
				margin-right: 16px;
				text-align: left;
				color: @darkBlack;
			}
			.base-cell-value {
				flex: 1;
				position: relative;
				overflow: hidden;
				color: #969799;
				vertical-align: middle;
				word-wrap: break-word;
				.base-cell-word-limit {
					margin: 20px 0;
					color: @subBlack;
					font-size: 14px;
					text-align: right;
					.blue {
						color: @baseBlue;
					}
					.red {
						color: @baseRed;
					}
				}
			}
		}
		.sticky-block {
			position: fixed;
			width: 100%;
			height: 70px;
			background: white;
			bottom: 0px;
			.button{
				width: 343px;
				margin: 0 auto;
				left: 16px;
			}
			.sticky-bottom{
				bottom: 20px;
			}
		}
	}

</style>
